import { PropsWithChildren, ReactNode, SyntheticEvent, Children } from 'react';
import { getSupplierUrl } from '@bridebook/toolbox/src';
import { IUISupplier } from '@bridebook/toolbox/src/types';
import { Box, FelaCSS } from '@bridebook/ui';
import { TRefSupplier } from '@bridebook/web/app-shared/lib/supplier/types';
import { generateReflinkUrl } from '@bridebook/web/lib/reflinks';
import LinkContentWrapper from '../link-content-wrapper';
import componentStyles from './content-frame.style';

export interface ISharedProps {
  featured?: boolean;
  isMobile?: boolean;
  fullBleed?: boolean;
}

interface IProps extends ISharedProps {
  passThroughStyle?: FelaCSS;
  topContent: ReactNode;
  supplier: IUISupplier;
  refSupplier?: TRefSupplier;
  supplierCardOnClick?: (supplier: IUISupplier, event: SyntheticEvent) => any;
}

const ContentFrame = ({
  topContent,
  featured,
  isMobile,
  passThroughStyle,
  supplier,
  supplierCardOnClick,
  children,
  fullBleed,
  refSupplier,
}: PropsWithChildren<IProps>) => {
  const supplierUrl = refSupplier
    ? generateReflinkUrl(getSupplierUrl(supplier), refSupplier)
    : getSupplierUrl(supplier);

  const onCustomClick = (event: SyntheticEvent<any>) =>
    typeof supplierCardOnClick === 'function' && supplierCardOnClick(supplier, event);

  const styles = componentStyles({ featured, isMobile, fullBleed });
  const [bottomContent, additionalContent] = Children.toArray(children);
  return (
    <Box style={{ ...styles.wrapper, ...passThroughStyle }} data-name="content-frame">
      <LinkContentWrapper onCustomClick={onCustomClick} supplierUrl={supplierUrl}>
        <div style={styles.additionalWrapper}>
          {topContent}
          {bottomContent}
        </div>
        {additionalContent}
      </LinkContentWrapper>
    </Box>
  );
};

export default ContentFrame;
